import React from 'react';

// can be used to disable lazy loading for an entire subtree
const LazyImageContext = React.createContext(false);
LazyImageContext.displayName = 'LazyImageContext';

export default LazyImageContext;
